export default __webpack_public_path__ + "static/img3@2x-0f99dfca82a13280bcfd19e134490c00.png";